// firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore'; // Firestore'u import edin
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyA2vKYXXNsg9WkHq4ortLeNClhxxsum244",
    authDomain: "aydinbuyuksehir-14cf4.firebaseapp.com",
    projectId: "aydinbuyuksehir-14cf4",
    storageBucket: "aydinbuyuksehir-14cf4.firebasestorage.app",
    messagingSenderId: "278092695354",
    appId: "1:278092695354:web:fb58a3d39ad05a64963203",
    measurementId: "G-WW2ZRYQQQR"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);
export { storage, auth, db };
